import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectBehaviourDesc, selectShowInvalids } from '@store/order/selectors';
import { setBehaviourDesc } from '@store/order/slice';
import calmCat from '@assets/images/order-calm-cat.svg';
import wildCat from '@assets/images/order-wild-cat.svg';
import { invalidFormValue } from '@components/utils';
import { CharacterEnum } from '@pages/order/animal-info/CharacterSection';



const CharacterSection = (): JSX.Element => {

	const behaviourDesc = useSelector(selectBehaviourDesc);
	const showInvalids = useSelector(selectShowInvalids);

	const dispatch = useDispatch();
	const updateBehaviourDesc = (value: string | null) => dispatch(setBehaviourDesc(value));

	return (
		<div className='character-section'>

			<label className='character-label'>
				Povaha <span>*</span> {showInvalids && invalidFormValue(behaviourDesc) &&
					<p className='form-invalid'>Povinné pole</p>}
			</label>

			<div className='character-elements'>

				<div className='character-element'>
					<div
						className={`character-icon disable-selection${behaviourDesc === CharacterEnum.calm ? ' active-character' : ''}`}
						onClick={() => updateBehaviourDesc(CharacterEnum.calm)}>
						<img src={calmCat} alt='calm-character-icon' draggable={false} />
					</div>
					
					<div className='character-icon-label'>
						<p>Kliďas</p>
					</div>
				</div>


				<div className='character-element'>
					<div
						className={`character-icon disable-selection${behaviourDesc === CharacterEnum.wild ? ' active-character' : ''}`}
						onClick={() => updateBehaviourDesc(CharacterEnum.wild)}>
						<img src={wildCat} alt='wild-character-icon' draggable={false} />
					</div>
					
					<div className='character-icon-label'>
						<p>Divoch</p>
					</div>
				</div>
			
			</div>
		</div>
	);
};

export default memo(CharacterSection);